import {NgModule} from "@angular/core";
import {EntityFormBuilder} from "./entity/edit/entity-form-builder/entity-form-builder";
import {SharedModule} from "../shared/shared.module";
import {LocalisationModule} from "../localisation/localisation.module";
import {SearchPageComponent} from "./entity/search/search-page/search-page.component";
import {SearchFormComponent} from "./entity/search/search-form/search-form.component";
import {
    SearchFormExtendedFieldsComponent
} from "./entity/search/search-form/extended-fields/search-form-extended-fields.component";
import {ExtendedSearchInputDirective} from "./entity/search/search-form/extended-search-input.directive";
import {SearchFormFieldComponent} from "./entity/search/search-form/field/search-form-field.component";
import {SearchFormFieldsComponent} from "./entity/search/search-form/fields/search-form-fields.component";
import {
    SearchFormFieldTemplateLoader
} from "./entity/search/search-form/field/search-form-field-template-loader.directive";
import {
    SimpleSearchControlComponent
} from "./common-controls/search-controls/simple-search-control/simple-search-control.component";
import {SearchGridComponent} from "./entity/search/search-grid/search-grid.component";
import {MainSearchColumnComponent} from "./entity/search/search-grid/columns/main-search-column.component";
import {ActionsSearchColumnComponent} from "./entity/search/search-grid/columns/actions-search-column.component";
import {
    CellTemplate,
    EditTemplate,
    FooterTemplate,
    HeaderTemplate,
    LinkTemplate
} from "./entity/grid/abstract-column.component";
import {SearchActionComponent, SearchActionSelector} from "./entity/search/search-grid/actions/search-action.component";
import {DeleteSearchActionComponent} from "./common-controls/actions/delete-search-action.component";
import {DiscontinueSearchActionComponent} from "./common-controls/actions/discontinue-search-action.component";
import {EditPageComponent} from "./entity/edit/edit-page/edit-page.component";
import {EditGridComponent, GridFormTemplate} from "./entity/edit/edit-grid/edit-grid.component";
import {EditGridFooterComponent} from "./entity/edit/edit-grid/edit-grid-footer/edit-grid-footer.component";
import {CurrencyColumnComponent} from "./common-controls/columns/currency-column/currency-column.component";
import {PercentageColumnComponent} from "./common-controls/columns/percentage-column/percentage-column.component";
import {CheckboxColumnComponent} from "./common-controls/columns/checkbox-column/checkbox-column.component";
import {NumericColumnComponent} from "./common-controls/columns/numeric-column/numeric-column.component";
import {TextColumnComponent} from "./common-controls/columns/text-column/text-column.component";
import {PropertyPipe} from "./entity/pipes/property.pipe";
import {EditLocalisationComponent} from "./entity/edit/edit-localisation/edit-localisation-component";
import {EditCollectionValidationComponent} from "./entity/edit/validation/edit-collection-validation.component";
import {EditGridAddRowComponent} from "./entity/edit/edit-grid/edit-grid-add-row/edit-grid-add-row.component";
import {
    NumericEditControlComponent
} from "./common-controls/edit-controls/numeric-edit-control/numeric-edit-control.component";
import {DateEditControlComponent} from "./common-controls/edit-controls/date-edit-control/date-edit-control.component";
import {TimeEditControlComponent} from "./common-controls/edit-controls/time-edit-control/time-edit-control.component";
import {
    EntityDiscontinuedEditControlComponent
} from "./common-controls/edit-controls/entity-discontinued-edit-control/entity-discontinued-edit-control.component";
import {
    EntityAvailabilityEditControlComponent
} from "./common-controls/edit-controls/entity-availability-edit-control/entity-availability-edit-control.component";
import {
    TextareaEditControlComponent
} from "./common-controls/edit-controls/textarea-edit-control/textarea-edit-control.component";
import {
    SwitchEditControlComponent
} from "./common-controls/edit-controls/switch-edit-control/switch-edit-control.component";
import {
    InvertedSwitchEditControlComponent
} from "./common-controls/edit-controls/inverted-switch-edit-control/inverted-switch-edit-control.component";
import {
    CheckboxEditControlComponent
} from "./common-controls/edit-controls/checkbox-edit-control/checkbox-edit-control.component";
import {
    EditGridSaveActionComponent
} from "./entity/edit/edit-grid/actions/edit-grid-save-action/edit-grid-save-action.component";
import {
    EditGridCancelActionComponent
} from "./entity/edit/edit-grid/actions/edit-grid-cancel-action/edit-grid-cancel-action.component";
import {WBODatePipe} from "./common-controls/pipes/date.pipe";
import {DateColumnComponent} from "./common-controls/columns/date-column/date-column.component";
import {WBODateTimePipe} from "./common-controls/pipes/date-time.pipe";
import {DateTimeColumnComponent} from "./common-controls/columns/date-time-column/date-time-column.component";
import {TimeColumnComponent} from "./common-controls/columns/time-column/time-column.component";
import {
    DateSearchControlComponent
} from "./common-controls/search-controls/date-search-control/date-search-control.component";
import {WBOTimePipe} from "./common-controls/pipes/time.pipe";
import {
    EntityAvailabilitySingleSelectSearchControlComponent
} from "./common-controls/search-controls/entity-availability-single-select-search-control/entity-availability-single-select-search-control.component";
import {TextEditControlComponent} from "./common-controls/edit-controls/text-edit-control/text-edit-control.component";
import {
    EditGridCellActivatorComponent
} from "./entity/edit/edit-grid/edit-grid-cell-activator/edit-grid-cell-activator.component";
import {
    EditGridAddRowActionsComponent
} from "./entity/edit/edit-grid/edit-grid-add-row/edit-grid-add-row-actions/edit-grid-add-row-actions.component";
import {
    EditGridAddRowNewEntityComponent
} from "./entity/edit/edit-grid/edit-grid-add-row/edit-grid-add-row-actions/edit-grid-add-row-new-entity.component";
import {
    EditGridAddRowSearchComponent
} from "./entity/edit/edit-grid/edit-grid-add-row/edit-grid-add-row-actions/edit-grid-add-row-search.component";
import {
    EditGridAddRowQuickAddComponent
} from "./entity/edit/edit-grid/edit-grid-add-row/edit-grid-add-rowquick-add/edit-grid-add-row-quick-add.component";
import {NgClickOutsideDirective} from "ng-click-outside2";
import {EditLinkComponent} from "./entity/edit/edit-link/edit-link.component";
import {EditLinkColumnComponent} from "./entity/edit/edit-link/edit-link-column.component";
import {
    EditGridReorderButtonsComponent
} from "./entity/edit/edit-grid/edit-grid-reorder-buttons/edit-grid-reorder-buttons.component";
import {
    EditGridReorderDragDropComponent
} from "./entity/edit/edit-grid/edit-grid-reorder-drag-drop/edit-grid-reorder-drag-drop.component";
import {SingleSelectControlComponent} from "./entity/select/single-select-control.component";
import {MultiSelectControlComponent} from "./entity/select/multi-select-control.component";
import {
    SingleSelectEditControlComponent
} from "./entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component";
import {MoreSelectControlComponent} from "./entity/select/more-select-control.component";
import {
    PasswordEditControlComponent
} from "./common-controls/edit-controls/password-edit-control/password-edit-control.component";
import {
    CurrencyEditControlComponent
} from "./common-controls/edit-controls/currency-edit-control/currency-edit-control.component";
import {SelectOptionsComponent} from "./entity/select/options/select-options.component";
import {SelectOptionComponent} from "./entity/select/options/select-option.component";
import {
    MultiSelectEditControlComponent
} from "./entity/edit/edit-controls/select-edit-controls/multi-select-edit-control.component";
import {
    InvertedCheckboxEditControlComponent
} from "./common-controls/edit-controls/inverted-checkbox-edit-control/inverted-checkbox-edit-control.component";
import {
    EditGridAddRowNewComponent
} from "./entity/edit/edit-grid/edit-grid-add-row/edit-grid-add-row-actions/edit-grid-add-row-new.component";
import {
    SingleSelectSearchControlComponent
} from "./entity/search/search-controls/select-search-controls/single-select-search-control.component";
import {
    MultiSelectSearchControlComponent
} from "./entity/search/search-controls/select-search-controls/multi-select-search-control.component";
import {SingleSelectColumnComponent} from "./entity/edit/edit-grid/columns/single-select-column.component";
import {ColorColumnComponent} from "./common-controls/columns/color-column/color-column.component";
import {
    ColorEditControlComponent
} from "./common-controls/edit-controls/color-edit-control/color-edit-control.component";
import {ColumnComponent} from "./entity/grid/column.component";
import {ReportPageComponent} from "./entity/report/report-page/report-page.component";
import {
    MessagingFooterButtonComponent
} from "../customer-support-messaging/messaging-footer-button/messaging-footer-button.component";
import {
    ImageEditControlComponent
} from "./common-controls/edit-controls/image-edit-control/image-edit-control.component";
import {EditGridCommandComponent} from "./entity/edit/edit-grid/edit-grid-command/edit-grid-command.component";
import {AddSearchActionComponent} from "./common-controls/actions/add-search-action.component";
import {EntityActionsComponent} from "./entity/actions/entity-actions.component";
import {EntityActionComponent} from "./entity/actions/entity-action.component";
import {InfoTextColumnComponent} from "./common-controls/columns/info-text-column/info-text-column.component";
import {InfoTextPopComponent} from "./common-controls/columns/info-text-column/info-text-pop.component";
import {TranslatedColumnComponent} from "./common-controls/columns/translated-column/translated-column.component";
import {FooterSpinnerComponent} from "./entity/footer-spinner/footer-spinner.component";
import {
    PercentageEditControlComponent
} from "./common-controls/edit-controls/percentage-edit-control/percentage-edit-control.component";
import {FilterPageComponent} from "./bi/filter/filter-page/filter-page.component";
import {PageNavsComponent} from "./common-controls/nav/page-navs/page-navs.component";
import {PageNavComponent} from "./common-controls/nav/page-navs/page-nav/page-nav.component";
import {ChartComponent} from "./bi/chart/chart.component";
import {BarChartComponent} from "./bi/chart/bar/bar-chart.component";
import {SummaryCardComponent} from "./bi/chart/summary-card/summary-card.component";
import {BlankChartComponent} from "./bi/chart/blank-chart/blank-chart.component";
import {PieChartComponent} from "./bi/chart/pie/pie-chart.component";
import {DonutChartComponent} from "./bi/chart/donut/donut-chart.component";
import {GridChartComponent} from "./bi/chart/grid-chart/grid-chart.component";
import {SecondsPipe} from "./common-controls/pipes/seconds.pipe";
import {BooleanSelectOptionsComponent} from "./common-controls/options/boolean-select-options.component";
import {ReportSearchActionComponent} from "./entity/report/actions/report-search-action.component";
import {OpenLinkColumnComponent} from "./entity/search/search-grid/columns/open-link-column.component";
import {CssVarDirective} from "./utils/css-var.directive";
import {
    FontSingleSelectEditControlComponent
} from "./common-controls/edit-controls/font-single-select-edit-control/font-single-select-edit-control.component";
import {
    FontStyleSingleSelectEditControlComponent
} from "./common-controls/edit-controls/font-style-single-select-edit-control/font-single-select-edit-control.component";
import {
    FontSizeSingleSelectEditControlComponent
} from "./common-controls/edit-controls/font-size-single-select-edit-control/font-single-select-edit-control.component";
import {ColorPairColumnComponent} from "./common-controls/columns/color-pair-column/color-pair-column.component";
import {ImageColumnComponent} from "./common-controls/columns/image-column/image-column.component";
import {
    EditPageUtilityControlsComponent
} from "./entity/edit/edit-page/edit-page-utility-controls/edit-page-utility-controls.component";
import {ElementWidthDirective} from "./utils/element-width.directive";
import {EditPageSidePanel} from "./entity/edit/edit-page/edit-page-side-panel/edit-page-side-panel.component";
import {
    EditPageFooterControlsComponent
} from "./entity/edit/edit-page/edit-page-footer-controls/edit-page-footer-controls.component";
import {MultiSelectColumnComponent} from "./entity/edit/edit-grid/columns/multi-select-column.component";
import {WBOCurrencyPipe} from "./common-controls/pipes/currency.pipe";
import {
    EditPageContentModeToggleControlComponent
} from "./entity/edit/edit-page/edit-page-utility-controls/edit-page-content-mode-toggle-control/edit-page-content-mode-toggle-control.component";
import {HtmlPipe} from "./common-controls/pipes/html.pipe";
import {
    EditGridFormEditModalComponent
} from "./entity/edit/edit-grid/edit-grid-form-edit/edit-grid-form-edit-modal.component";
import {UrlPipe} from "./common-controls/pipes/url.pipe";
import {
    EditPageFooterButtonsComponent
} from "./entity/edit/edit-page/edit-page-footer-buttons/edit-page-footer-buttons.component";
import {EditGridMessageComponent} from "./entity/edit/edit-grid/edit-grid-message/edit-grid-message.component";
import {EditControlLabelContextComponent} from "./entity/edit/edit-controls/edit-control-label-context.component";
import {SearchGridHeaderComponent} from "./entity/search/search-grid/search-grid-header.component";
import {
    NumericSearchControlComponent
} from "./common-controls/search-controls/numeric-search-control/numeric-search-control.component";
import {
    EditGridAddRowCustomComponent
} from "./entity/edit/edit-grid/edit-grid-add-row/edit-grid-add-row-actions/edit-grid-add-row-custom.component";
import {
    BooleanRadioEditControlComponent
} from "./common-controls/edit-controls/boolean-radio-edit-control/boolean-radio-edit-control.component";
import {UrlLinkColumnComponent} from "./entity/search/search-grid/columns/url-link-column.component";
import {SpinnerControlComponent} from "./common-controls/edit-controls/spinner-control/spinner-control.component";

/**
 * The Framework Module provides the entity search and edit UI framework.
 *
 * This module should be generic in that it does not implement functionality
 * specific to any particular entity.
 */
@NgModule({
    imports: [
        SharedModule,
        LocalisationModule,
        NgClickOutsideDirective
    ],
    declarations: [
        // SEARCH
        SearchPageComponent,

        // Search form
        SearchFormComponent,
        SearchFormExtendedFieldsComponent,
        ExtendedSearchInputDirective,
        SearchFormFieldComponent,
        SearchFormFieldsComponent,
        SearchFormFieldTemplateLoader,

        // Search controls
        SimpleSearchControlComponent,
        NumericSearchControlComponent,
        EntityAvailabilitySingleSelectSearchControlComponent,
        DateSearchControlComponent,
        SingleSelectSearchControlComponent,
        MultiSelectSearchControlComponent,

        // Search grid
        SearchGridComponent,
        SearchGridHeaderComponent,

        // Search columns
        MainSearchColumnComponent,
        ActionsSearchColumnComponent,
        OpenLinkColumnComponent,
        UrlLinkColumnComponent,

        // Search actions
        SearchActionComponent,
        DeleteSearchActionComponent,
        AddSearchActionComponent,
        DiscontinueSearchActionComponent,
        SearchActionSelector,

        // EDIT
        EditPageComponent,
        EditPageSidePanel,
        EditPageUtilityControlsComponent,
        EditPageFooterButtonsComponent,
        EditPageFooterControlsComponent,
        EntityActionsComponent,
        EntityActionComponent,
        EditPageContentModeToggleControlComponent,

        // Edit controls
        SwitchEditControlComponent,
        InvertedSwitchEditControlComponent,
        TextEditControlComponent,
        ImageEditControlComponent,
        ColorEditControlComponent,
        FontSingleSelectEditControlComponent,
        FontStyleSingleSelectEditControlComponent,
        FontSizeSingleSelectEditControlComponent,
        PasswordEditControlComponent,
        TextareaEditControlComponent,
        EntityAvailabilityEditControlComponent,
        EntityDiscontinuedEditControlComponent,
        DateEditControlComponent,
        TimeEditControlComponent,
        NumericEditControlComponent,
        CurrencyEditControlComponent,
        PercentageEditControlComponent,
        BooleanRadioEditControlComponent,
        CheckboxEditControlComponent,
        InvertedCheckboxEditControlComponent,
        EditLocalisationComponent,
        SingleSelectEditControlComponent,
        MultiSelectEditControlComponent,
        EditControlLabelContextComponent,

        // Edit grid
        EditGridComponent,
        EditGridAddRowComponent,
        EditGridAddRowActionsComponent,
        EditGridAddRowSearchComponent,
        EditGridAddRowNewEntityComponent,
        EditGridAddRowQuickAddComponent,
        EditGridAddRowNewComponent,
        EditGridAddRowCustomComponent,
        EditGridCellActivatorComponent,
        EditGridReorderButtonsComponent,
        EditGridReorderDragDropComponent,
        EditLinkComponent,
        EditLinkColumnComponent,
        EditGridCommandComponent,
        EditGridMessageComponent,
        EditGridCancelActionComponent,
        EditGridSaveActionComponent,
        EditGridFooterComponent,
        GridFormTemplate,
        EditGridFormEditModalComponent,

        // Edit validation
        EditCollectionValidationComponent,

        // PIPES
        PropertyPipe,
        SecondsPipe,
        HtmlPipe,
        UrlPipe,
        WBOCurrencyPipe,
        WBODatePipe,
        WBOTimePipe,
        WBODateTimePipe,

        // COLUMN
        ColumnComponent,
        HeaderTemplate,
        FooterTemplate,
        CellTemplate,
        LinkTemplate,
        EditTemplate,

        // Column components
        CurrencyColumnComponent,
        PercentageColumnComponent,
        CheckboxColumnComponent,
        NumericColumnComponent,
        ColorColumnComponent,
        ColorPairColumnComponent,
        TextColumnComponent,
        DateColumnComponent,
        DateTimeColumnComponent,
        TimeColumnComponent,
        InfoTextColumnComponent,
        InfoTextPopComponent,
        TranslatedColumnComponent,
        SingleSelectColumnComponent,
        MultiSelectColumnComponent,
        ImageColumnComponent,

        // SELECT
        SingleSelectControlComponent,
        MultiSelectControlComponent,
        MoreSelectControlComponent,
        SelectOptionsComponent,
        SelectOptionComponent,

        // REPORT
        ReportPageComponent,
        ReportSearchActionComponent,

        // BUTTONS
        MessagingFooterButtonComponent,

        // SPINNERS
        FooterSpinnerComponent,
        SpinnerControlComponent,

        // BI
        FilterPageComponent,
        ChartComponent,
        BarChartComponent,
        PieChartComponent,
        DonutChartComponent,
        SummaryCardComponent,
        BlankChartComponent,
        GridChartComponent,

        // NAVS
        PageNavsComponent,
        PageNavComponent,

        // OPTIONS
        BooleanSelectOptionsComponent,

        // Directives
        CssVarDirective,
        ElementWidthDirective,
    ],
    exports: [
        // SEARCH
        SearchPageComponent,

        // Search form
        SearchFormComponent,
        SearchFormExtendedFieldsComponent,
        ExtendedSearchInputDirective,
        SearchFormFieldComponent,
        SearchFormFieldsComponent,
        SearchFormFieldTemplateLoader,

        // Search controls
        SimpleSearchControlComponent,
        NumericSearchControlComponent,
        EntityAvailabilitySingleSelectSearchControlComponent,
        DateSearchControlComponent,
        SingleSelectSearchControlComponent,
        MultiSelectSearchControlComponent,

        // Search grid
        SearchGridComponent,
        SearchGridHeaderComponent,

        // Search columns
        MainSearchColumnComponent,
        ActionsSearchColumnComponent,
        OpenLinkColumnComponent,
        UrlLinkColumnComponent,

        // Search actions
        SearchActionComponent,
        DeleteSearchActionComponent,
        AddSearchActionComponent,
        DiscontinueSearchActionComponent,
        SearchActionSelector,

        // EDIT
        EditPageComponent,
        EditPageSidePanel,
        EditPageUtilityControlsComponent,
        EditPageFooterButtonsComponent,
        EditPageFooterControlsComponent,
        EntityActionsComponent,
        EntityActionComponent,
        EditPageContentModeToggleControlComponent,

        // Edit controls
        SwitchEditControlComponent,
        InvertedSwitchEditControlComponent,
        TextEditControlComponent,
        ImageEditControlComponent,
        ColorEditControlComponent,
        FontSingleSelectEditControlComponent,
        FontStyleSingleSelectEditControlComponent,
        FontSizeSingleSelectEditControlComponent,
        PasswordEditControlComponent,
        TextareaEditControlComponent,
        EntityAvailabilityEditControlComponent,
        EntityDiscontinuedEditControlComponent,
        DateEditControlComponent,
        TimeEditControlComponent,
        NumericEditControlComponent,
        CurrencyEditControlComponent,
        PercentageEditControlComponent,
        BooleanRadioEditControlComponent,
        CheckboxEditControlComponent,
        InvertedCheckboxEditControlComponent,
        EditLocalisationComponent,
        SingleSelectEditControlComponent,
        MultiSelectEditControlComponent,
        EditControlLabelContextComponent,

        // Edit grid
        EditGridComponent,
        EditGridAddRowComponent,
        EditGridAddRowActionsComponent,
        EditGridAddRowSearchComponent,
        EditGridAddRowNewEntityComponent,
        EditGridAddRowQuickAddComponent,
        EditGridAddRowNewComponent,
        EditGridAddRowCustomComponent,
        EditGridCellActivatorComponent,
        EditGridReorderButtonsComponent,
        EditGridReorderDragDropComponent,
        EditLinkComponent,
        EditLinkColumnComponent,
        EditGridCommandComponent,
        EditGridMessageComponent,
        EditGridCancelActionComponent,
        EditGridSaveActionComponent,
        EditGridFooterComponent,
        GridFormTemplate,
        EditGridFormEditModalComponent,

        // Edit validation
        EditCollectionValidationComponent,

        // PIPES
        PropertyPipe,
        SecondsPipe,
        HtmlPipe,
        UrlPipe,
        WBOCurrencyPipe,
        WBODatePipe,
        WBOTimePipe,
        WBODateTimePipe,

        // COLUMN
        ColumnComponent,
        HeaderTemplate,
        FooterTemplate,
        CellTemplate,
        LinkTemplate,
        EditTemplate,

        // Column components
        CurrencyColumnComponent,
        PercentageColumnComponent,
        CheckboxColumnComponent,
        NumericColumnComponent,
        ColorColumnComponent,
        ColorPairColumnComponent,
        TextColumnComponent,
        DateColumnComponent,
        DateTimeColumnComponent,
        TimeColumnComponent,
        InfoTextColumnComponent,
        InfoTextPopComponent,
        TranslatedColumnComponent,
        SingleSelectColumnComponent,
        MultiSelectColumnComponent,
        ImageColumnComponent,

        // SELECT
        SingleSelectControlComponent,
        MultiSelectControlComponent,
        MoreSelectControlComponent,
        SelectOptionsComponent,
        SelectOptionComponent,

        // REPORT
        ReportPageComponent,
        ReportSearchActionComponent,

        // BUTTONS
        MessagingFooterButtonComponent,

        // SPINNERS
        FooterSpinnerComponent,
        SpinnerControlComponent,

        // BI
        FilterPageComponent,
        ChartComponent,
        BarChartComponent,
        PieChartComponent,
        DonutChartComponent,
        SummaryCardComponent,
        BlankChartComponent,
        GridChartComponent,

        // NAVS
        PageNavsComponent,
        PageNavComponent,

        // OPTIONS
        BooleanSelectOptionsComponent,

        // Directives
        CssVarDirective,
        ElementWidthDirective,
    ],
    providers: [
        EntityFormBuilder
    ]
})
export class FrameworkModule {
}
